export default __webpack_public_path__ + "static/bg-c671a03185689d0b336db4841b10e3d3.svg";